import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Output,
} from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';

@Component({
  standalone: true,
  imports: [MatButtonModule, MatIconModule],
  selector: 'app-mini-fab',
  template: `
    <div class="mini-fab-container">
      <button
        mat-mini-fab
        class="mini-fab"
        type="button"
        aria-label="Close"
        (click)="close.emit()"
      >
        <mat-icon>close</mat-icon>
      </button>
      <button
        mat-mini-fab
        class="mini-fab"
        type="button"
        aria-label="Move Right"
        (click)="moveright.emit()"
      >
        <mat-icon>arrow_right_alt</mat-icon>
      </button>
      <button
        mat-mini-fab
        class="mini-fab"
        type="button"
        aria-label="Move Down"
        (click)="movedown.emit()"
      >
        <mat-icon>arrow_downward</mat-icon>
      </button>
    </div>
  `,
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./mini-fab.component.scss'],
})
export class MiniFabComponent {
  @Output() close = new EventEmitter<void>();
  @Output() moveright = new EventEmitter<void>();
  @Output() movedown = new EventEmitter<void>();
}
